<template>
  <el-tree
    ref="areaTree"
    :data="list"
    show-checkbox
    node-key="id"
    :default-expanded-keys="expanded_keys"
    :default-checked-keys="checked_keys"
    :props="defaultProps"
    @check="handleCheck"
    @node-click="nodeClick"
    v-loading="loading"
  >
  </el-tree>
</template>

<script>
import District from "~/services/district";
import elietschool from "~/services/elietschool";
import bus from "~/common/eventBus";
export default {
  name: "EliteSchoolArea",
  props: {
    customer: {},
    customer_id: {
      type: Number | String,
      required: true,
    },
  },
  data() {
    return {
      list: [],
      loading: false,
      defaultProps: {
        children: "children",
        label: "label",
      },
      expanded_keys: [],
      checked_keys: [],
    };
  },
  created() {
    this.getList();
    this.getCheckedId();

  },
  methods: {
    getList() {
      this.loading = true;
      District.getTreeList().then((res) => {
        if (res.code == 0) {
          this.list = [
            {
              id: 0,
              label: "全部",
              children: res.data,
            },
          ];
          this.loading = false;
        }
      });
      return true;
    },

    getCheckedId() {
      this.loading = true;
      let params = {
        customer_id: parseInt(this.customer_id),
      };
      elietschool.getCheckedId(params).then((res) => {
        if (res.code == 0) {
          this.expanded_keys = res.data;
          this.checked_keys = res.data;
          if(!this.checked_keys || this.checked_keys.length == 0){
            this.expanded_keys = [-1,this.customer.province_id];
            this.checked_keys = [-1,this.customer.province_id];
          }
        }
        this.loading = false;
      });
      return true;
    },

    handleCheck(data, obj) {
      this.loading = true;
      var is_all = 0;//是否全选
      var checked_keys = obj.checkedKeys;//获取选中key值数组
      //通过选中的结点数量变化，判断是点击勾选还是点击取消勾选
      if(data.id == 0){
        is_all = 2;//全部取消
        if(checked_keys.length > 0){
          //数量增加肯定就是点击了勾选
          is_all = 1;
        }
      }else if(checked_keys.includes(0)){
        is_all = 1;
      }else if(checked_keys.length == 0){
        is_all = 2;//全部取消
      }
      var params = {
        customer_id: parseInt(this.customer_id),
        district_ids: checked_keys,
        is_all: is_all
      };
      elietschool.districtCheck(params).then((res) => {
        this.loading = false;
        if (res.code) {
          this.$message({ type: "error", message: "设置更新失败" });
          this.getList();
          this.getCheckedId();
          return false;
        }
        this.$message({
          type: "success",
          message: "设置更新成功",
        });
        // bus.$emit('refresh', data);
        return true;
      });
    },

    nodeClick(data, node, ojb){
      console.log('点击节点', data, node, ojb);
    }
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/views/order/jiaoben/eliteSchoolArea.vue